import { apiUrl }  from "../constants";
var axios = require('axios');
var request = axios.create({
    baseURL: apiUrl,
    headers: {'Authorization':localStorage.getItem('token'),'Content-Type':'application/json'}
})
export default class RefereesApi {
    static getAll(status) {
        return request.get(`/referees/${localStorage.getItem("rol")}?status=${status}`);
    }

    static get(id) {
        return request.get(`/referees/${localStorage.getItem("rol")}/${id}`);
    }

    static create(referee) {
        return request.post('/referees',{referee: referee });
    }

    static edit(referee, id){
        return request.put(`/referees/${id}`, {referee: referee});
    }

    static delete(id){
        return request.delete(`referees?id=${id}`);
    }
}


// WEBPACK FOOTER //
// ./src/api/Referees.js